import React, { useRef } from "react";
import { Outlines, useGLTF } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

export default function Model(props) {
  const { nodes, materials } = useGLTF("/plots/06-Apartment.glb");
  const outlineThickness = .008

  let built = props.built
  const model = useRef()

  useFrame((state, delta) => {
    if(!built && model.current.scale.y < 1)
    {
      AnimateIn()
    }
    else
    {
      IdleAnimation()
    }
  })

  function AnimateIn() {
    model.current.scale.y += (1 - model.current.scale.y) / 10
    model.current.scale.x += (1 - model.current.scale.x) / 10
    model.current.scale.z += (1 - model.current.scale.z) / 10
    if(model.current.scale.y > .997)
    {
      model.current.scale.x = 1
      model.current.scale.y = 1
      model.current.scale.z = 1
      // console.log(model.current.scale)
    }
  }

  function IdleAnimation()
  {
    // console.log('idleAnimating')
  }

  
  return (
    <group {...props} dispose={null} ref={model} scale={[.7,.2,.7]}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube026.geometry}
        material={materials["14-ApartmentsFloor2"]}
        position={[0.702, 0.941, -0.676]}
        rotation={[0, -Math.PI / 2, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube150.geometry}
        material={materials["14-ApartmentsFloor1"]}
        position={[0, 0.299, -0.356]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube152.geometry}
        material={materials["14-ApartmentsFloor3"]}
        position={[0, 1.022, -0.356]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube166.geometry}
        material={materials["10-ResidentialSiding"]}
        position={[0, 0.389, 0.192]}
        rotation={[0.1, 0, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube174.geometry}
        material={materials["07-WindowMat"]}
        position={[0, 0.675, -0.356]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube175.geometry}
        material={materials["06-WindowSill2"]}
        position={[0, 0.675, -0.356]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube216.geometry}
        material={materials["07-GlassMat"]}
        position={[0.702, 0.941, -0.676]}
        rotation={[0, -Math.PI / 2, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube224.geometry}
        material={materials["00-Base3"]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube382.geometry}
        material={materials["11-SidewalkConcrete"]}
        position={[-0.001, 0.101, 0.546]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube442.geometry}
        material={materials["00-Grass1"]}
        position={[0.856, 0.116, -0.355]}
        rotation={[0, Math.PI / 2, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube446.geometry}
        material={materials["01-TreeTrunk"]}
        position={[-0.841, 0.157, -0.07]}
        rotation={[-Math.PI, 1.455, -Math.PI]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder165.geometry}
        material={materials["01-TreeGreen2"]}
        position={[0.816, 0.422, -0.345]}
        rotation={[-Math.PI, 1.43, -Math.PI]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder170.geometry}
        material={materials["01-TreeGreen1"]}
        position={[-0.841, 0.229, -0.07]}
        rotation={[-Math.PI, 1.455, -Math.PI]}
      ><Outlines thickness={outlineThickness}/></mesh>
    </group>
  );
}

useGLTF.preload("/plots/06-Apartment.glb");